import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Checkbox } from '@/components/ui/checkbox';
import { Server } from 'lucide-react';
import { INFRASTRUCTURE_TYPES, EXISTING_CERTS } from '@/lib/calculationEngine';

export function ScopeInfrastructure({ config, updateConfig }) {
  const { t } = useTranslation();
  const toggleCert = (certValue) => {
    const current = config.existingCerts || [];
    const updated = current.includes(certValue)
      ? current.filter(c => c !== certValue)
      : [...current, certValue];
    updateConfig({ existingCerts: updated });
  };

  return (
    <Card className="bg-white border-[#DDE1E5]" data-testid="scope-infrastructure-section">
      <CardHeader className="pb-4">
        <CardTitle
          className="flex items-center gap-2 text-lg text-[#171A1D]"
          style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
        >
          <Server className="w-5 h-5 text-[#66707A]" />
          {t('scope.title')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        <div>
          <Label className="text-[#66707A] text-sm" id="infra-type-label">{t('scope.infraType')}</Label>
          <RadioGroup
            value={config.infrastructure}
            onValueChange={v => updateConfig({ infrastructure: v })}
            className="mt-2 flex flex-wrap gap-4"
            aria-labelledby="infra-type-label"
          >
            {INFRASTRUCTURE_TYPES.map(infra => (
              <div key={infra.value} className="flex items-center gap-2">
                <RadioGroupItem value={infra.value} id={`infra-${infra.value}`} data-testid={`infra-${infra.value}`} />
                <Label
                  htmlFor={`infra-${infra.value}`}
                  className="text-sm text-[#171A1D] cursor-pointer"
                >
                  {t('calcData.infra.' + infra.value)}
                  <span className="text-[#66707A] ml-1 text-xs">({infra.multiplier}x)</span>
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>

        <div>
          <Label className="text-[#66707A] text-sm mb-2 block">
            {t('scope.existingCerts')}
          </Label>
          <p className="text-xs text-[#8A929B] mb-3">
            {t('scope.certsHelp')}
          </p>
          <div className="grid sm:grid-cols-2 gap-3">
            {EXISTING_CERTS.map(cert => (
              <div key={cert.value} className="flex items-center gap-2">
                <Checkbox
                  id={`cert-${cert.value}`}
                  checked={(config.existingCerts || []).includes(cert.value)}
                  onCheckedChange={() => toggleCert(cert.value)}
                  data-testid={`cert-${cert.value}`}
                />
                <Label
                  htmlFor={`cert-${cert.value}`}
                  className="text-sm text-[#171A1D] cursor-pointer"
                >
                  {cert.label}
                  <span className="text-[#78B928] ml-1 text-xs">(-{Math.round(cert.reduction * 100)}%)</span>
                </Label>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
